// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BKd_","text":"styles_text__ENqoC","btn":"styles_btn__3t6lJ"};